import React from "react";
import { StyleSheet } from "react-native";
import { PdText, tPdText } from "src/components/layout";
import { kColors } from "src/kColors";

export const PdFormLabel: React.FC<tPdText> = ({ style, ...rest }) => (
  <PdText style={[styles.pdFormLabel, style]} {...rest} />
);

export const PdFormHelperText: React.FC<tPdText> = ({ style, ...rest }) => (
  <PdText variant="body-xs" style={[styles.pdFormHelperText, style]} {...rest} />
);

export const PdFormErrorText: React.FC<tPdText> = ({ style, ...rest }) => (
  <PdText variant="body-xs" style={[styles.pdFormErrorText, style]} {...rest} />
);

const styles = StyleSheet.create({
  pdFormErrorText: {
    color: kColors.red,
    lineHeight: 20,
  },
  pdFormHelperText: {
    color: kColors.gray500,
  },
  pdFormLabel: {
    color: kColors.brand500,
    fontSize: 12,
    letterSpacing: 1.2,
    lineHeight: 30,
  },
});
